import React from 'react';
import { useNavigate } from 'react-router-dom';

const FeedbackPage = () => {
  const navigate = useNavigate();
  return (
    <div className="max-w-xl mx-auto py-10 px-4">
      <button
        className="flex items-center gap-2 mb-6 text-primary hover:underline"
        onClick={() => navigate('/')}>
        <span className="material-symbols-outlined">arrow_back</span>
        Back
      </button>
      <h2 className="text-xl font-semibold mt-6 mb-2">Feedback</h2>
      <p className="mb-2">
        We’d love to hear your thoughts, suggestions, or bug reports. Feel free to reach out anytime:
      </p>
      <p className="mb-2">
        📧 Email: <a href="mailto:mohamedqadar280@gmail.com" className="text-primary underline">mohamedqadar280@gmail.com</a>
      </p>
      <p className="mb-2 flex items-center">
        <a
          href="https://wa.me/905531714783"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center text-primary hover:underline"
          aria-label="WhatsApp"
        >
          <span className="material-symbols-outlined text-xl mr-1" style={{ color: '#25D366' }}>chat</span>
          WhatsApp
        </a>
      </p>
      <p className="mt-4">Your feedback helps us build smarter tools for Africa’s digital future. 🌍</p>
      <div className="mt-10 text-center text-xs text-gray-500">
        © 2025 Software Development East Africa (SODEAF). All rights reserved.
      </div>
    </div>
  );
};

export default FeedbackPage;
